import { render, staticRenderFns } from "./studyCenter.vue?vue&type=template&id=c8c38490&scoped=true"
import script from "./studyCenter.vue?vue&type=script&lang=js"
export * from "./studyCenter.vue?vue&type=script&lang=js"
import style0 from "./studyCenter.vue?vue&type=style&index=0&id=c8c38490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c38490",
  null
  
)

export default component.exports